import React from 'react';
import PropTypes from 'prop-types';

const TabPanel = props => {
  const { tabId, tabLabel, tabLinkProps, selected, disabled, children, className, ...rest } = props;

  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};

TabPanel.propTypes = {
  tabId: PropTypes.string.isRequired,
  tabLabel: PropTypes.string.isRequired,
  tabLinkProps: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TabPanel;
